import { ChamberMember, CodebookModel, FileWrapper } from 'app/shared/model/shared.model';
import { DesignerOffice } from 'app/edozvola/cases/project-documents/model/project-documents.model';
import { initialAddress } from 'app/shared/address-input/model/address.model';

export interface MainProjectDataModel {
  mainProjectType: CodebookModel[];
  projectMark: string;
  mainProjectAuthorizedDesigner: ChamberMember;
  mainProjectAuthorizationNumberExists: boolean;
  mainProjectDesignerFirstName: string;
  mainProjectDesignerLastName: string;
  mainProjectDesignerTitle: string;
}

export interface MainProjectDocumentModel {
  projectTypeByVocationalDesignation: CodebookModel[];
  projectMark: string;
  additionalDescription: string;
  projectCreatedDate: Date;
  projectMap: CodebookModel[];
  authorizedDesigner: ChamberMember;
  designerOffice: DesignerOffice;
  authorizationNumberExists: boolean;
  v2card: boolean;
  designerFirstName: string;
  designerLastName: string;
  designerTitle: string;
  email?: string;
  telephoneNumber?: string;
}

export interface MainProjectDocumentView {
  idMainProjectDocument: number;
  projectTypeByVocationalDesignation: string;
  additionalDescription: string;
  authorizedDesigner: string;
  designerOfficeAddress: string;
  projectMap: string;
  projectMark: string;
  projectCreatedDate: Date;
  hasAttachments: boolean;
  canEdit: boolean;
  canDelete: boolean;
  ordering: number;
}

export interface MainProjectDocumentAttachmentView {
  idMainProjectDocumentAttachment: number;
  name: string;
  createdDate: Date;
  lastValidSignature: string;
  lastSignerInstitution: string;
  status: boolean;
  canDelete: boolean;
}

export const projectDataInitial = {
  mainProjectType: [],
  projectMark: '',
  mainProjectAuthorizedDesigner: {
    authorizationNumber: [],
    oib: '',
  },
  mainProjectAuthorizationNumberExists: true,
  mainProjectDesignerFirstName: '',
  mainProjectDesignerLastName: '',
  mainProjectDesignerTitle: '',
};

export const mainProjectDocumentInitial = {
  projectTypeByVocationalDesignation: [],
  projectMark: '',
  additionalDescription: '',
  projectCreatedDate: '',
  projectMap: [],
  authorizedDesigner: {
    authorizationNumber: [],
    oib: '',
  },
  designerOffice: {
    oibFetched: true,
    subjectType: [],
    legalEntity: {
      oib: '',
      mb: '',
      companyName: '',
      address: null,
    },
    address: initialAddress,
  },
  authorizationNumberExists: true,
  v2card: false,
  designerFirstName: '',
  designerLastName: '',
  designerTitle: '',
  email: '',
  telephoneNumber: '+385',
};
